import { render } from "./AppDefaultLayout.vue?vue&type=template&id=6975e710"
const script = {}
script.render = render

export default script